import { render, staticRenderFns } from "./FuturesOperationsForm.vue?vue&type=template&id=3f105e84&scoped=true&"
import script from "./FuturesOperationsForm.vue?vue&type=script&lang=js&"
export * from "./FuturesOperationsForm.vue?vue&type=script&lang=js&"
import style0 from "./FuturesOperationsForm.vue?vue&type=style&index=0&id=3f105e84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f105e84",
  null
  
)

export default component.exports